import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './language-selector.module.css';

export const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
  };
  return (
    <div className={styles['language-selector']}>
      <span
        className={i18n.language === 'ro' ? styles['active'] : ''}
        onClick={() => {
          handleLanguageChange('ro');
        }}
      >
        RO
      </span>
      <span
        className={i18n.language === 'ru' ? styles['active'] : ''}
        onClick={() => {
          handleLanguageChange('ru');
        }}
      >
        RU
      </span>
      <span
        className={i18n.language === 'en' ? styles['active'] : ''}
        onClick={() => {
          handleLanguageChange('en');
        }}
      >
        EN
      </span>
      <span
        className={i18n.language === 'pl' ? styles['active'] : ''}
        onClick={() => {
          handleLanguageChange('pl');
        }}
      >
        PL
      </span>
      <span
        className={i18n.language === 'es-MX' ? styles['active'] : ''}
        onClick={() => {
          handleLanguageChange('es-MX');
        }}
      >
        ES
      </span>
    </div>
  );
};
